import React, { Component } from 'react'
// import { storeData } from '../../../storeData'

export default class Reembolso extends Component {
  render() {
    const {storeData} = this.props
    return (
      <div className='DefaultPage'>
<h2>

Política de reembolso
</h2>

<h2>

Cambios y devoluciones
</h2>

<p>

Cualquier compra realizada a través de las modalidades de entrega aquí mencionadas, disponen de un plazo para cambios de 5 días calendario a partir de la fecha de recepción de tu compra. Debes presentar tu solicitud antes que se cumplan los 5 días calendario, a través de alguno de nuestros canales de atención. El término máximo para ejercer el derecho de retracto será de cinco (5) días hábiles contados a partir de la entrega del bien.
</p>

<p>

El consumidor deberá devolver el producto al productor o proveedor por los mismos medios y en las mismas condiciones en que lo recibió. Los costos de transporte y los demás que conlleve la devolución del bien serán cubiertos por el consumidor.
</p>

<p>

Se exceptúan del derecho de retracto, los siguientes casos:
</p>


<p>

1. En los contratos de prestación de servicios cuya prestación haya comenzado con el acuerdo del consumidor;
</p>

<p>

2. En los contratos de suministro de bienes o servicios cuyo precio esté sujeto a fluctuaciones de coeficientes del mercado financiero que el productor no pueda controlar;
</p>

<p>

3. En los contratos de suministro de bienes confeccionados conforme a las especificaciones del consumidor o claramente personalizados;
</p>

<p>

4. En los contratos de suministro de bienes que, por su naturaleza, no puedan ser devueltos o puedan deteriorarse o caducar con rapidez;
</p>

<p>

5. En los contratos de servicios de apuestas y loterías;
</p>

<p>

6. En los contratos de adquisición de bienes perecederos;
</p>

<p>

7. En los contratos de adquisición de bienes de uso personal.
</p>

<p>

La devolución del dinero al consumidor no podrá exceder de treinta (30) días calendario desde el momento en que ejerció el derecho.
</p>


<h2>

Debes tener en cuenta:
</h2>

<p>

Debes realizar la solicitud a través de nuestros canales de comunicación.
Debes devolver el producto por medio de una de las transportadoras del país. El cliente acepta que los costos de envío ocasionados por esta devolución deben correr por su cuenta.
Utiliza el mismo empaque en que te entregamos tu pedido o utiliza un empaque de tu preferencia teniendo en cuenta la naturaleza del producto para que éste no se pueda ver afectado durante el proceso de transporte.
El producto deberá devolverse en óptimas condiciones, sin rastros de haber sido utilizado, con las etiquetas originales o en su defecto, si ya fueron retiradas, debes introducirlas en el empaque.
Al recibir el producto en nuestras bodegas, verificaremos las condiciones del mismo.
Cambios
</p>

<h2>

Cambio del producto por talla o color:
</h2>

<p>

Para compras realizadas en {storeData.domain} y WhatsApp, debes tener en cuenta:

Se podrán realizar cambios por productos con valor igual, inferior o superior al original, así:
Menor valor: La diferencia en caso de aplicar se entregará en un vale electrónico para una nueva compra en la tienda online. Aplica para {storeData.domain} y Ventas por WhatsApp.
Mayor valor: se enviará un vale electrónico por el valor pagado y la diferencia en caso de aplicar debe ser asumida por el cliente en el momento de realizar la compra.
En caso de no contar con disponibilidad para el cambio, se entregará el valor del producto en un vale electrónico para una nueva compra.
Los cambios se despacharán aproximadamente en 5 días hábiles siguientes de recibido el producto en la bodega y aplicarán los mismos tiempos de una entrega regular.
Vale electrónico
Validez por 3 meses a partir de la fecha de creación
Aplica para realizar una nueva compra en {storeData.domain}
Se enviará aproximadamente en 4 días hábiles después de recibido el producto en la bodega.
Solo podrá ser utilizado por la persona que lo solicitó y se activara con el número de identificación.
Reembolso del dinero {storeData.domain}
Solo para solicitudes por efectividad de la garantía por calidad de producto y derecho de retracto.
Al recibir el producto en nuestra bodega, te enviaremos un formato de solicitud de reembolso para que lo diligencies, una vez te confirmemos el recibido de este formato empezará a contar el tiempo para tu reembolso.
Los reembolsos de dinero se harán a través de una transferencia electrónica o a tu tarjeta de crédito, dependiendo del medio de pago que hayas utilizado para tu compra.
Los reembolsos parciales se procesarán por medio de transferencia electrónica a una cuenta de ahorros o por giro Efecty.
El proceso a través de transferencia electrónica puede tomar de 5 a 7 días hábiles una vez confirmados tus datos y de que nos remitas el formato de rembolso.
El reembolso a tu tarjeta de crédito puede tomar hasta 30 días hábiles, este tiempo es estimado y está sujeto al proceso interno del banco emisor de la tarjeta.
{storeData.domain} no será responsable por deducciones o retenciones de dinero por concepto de servicios que la entidad financiera efectúe.
En caso de que tu producto no cumpla con las condiciones para aceptar la devolución. Te informaremos con mensaje a tu correo electrónico la razón por la cual no procede y el producto será devuelto a la dirección de envío inicial.
</p>
      </div>
    )
  }
}
